/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Communication Log Item
 */
export type CommLogRecordItem = {
    /**
     * API Response Version
     */
    _ver?: number;
    /**
     * Record Unique ID
     */
    id?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    created?: number;
    /**
     * Unix Timestamp - To Seconds Precision
     */
    updated?: number;
    /**
     * Timestamp - if sent is blank returns created
     */
    sent?: number;
    /**
     * Query Header Text
     */
    body?: string;
    /**
     * Log Reference Type
     */
    contextTable?: string;
    /**
     * Log Reference ID
     */
    contextId?: number;
    /**
     * Error Message
     */
    error?: string;
    /**
     * Recipient Name
     */
    name?: string;
    /**
     * Subject
     */
    subject?: string;
    /**
     * Notification Destination
     */
    destination?: string;
    /**
     * Notification Sender Name
     */
    sentName?: string;
    /**
     * Notification Sender Address
     */
    sentAddress?: string;
    /**
     * Type
     */
    notifyType?: CommLogRecordItem.notifyType;
    /**
     * Status
     */
    notifyStatus?: CommLogRecordItem.notifyStatus;
}

export namespace CommLogRecordItem {

    /**
     * Type
     */
    export enum notifyType {
        EMAIL = 'email',
        SMS = 'sms',
        APP = 'app',
    }

    /**
     * Status
     */
    export enum notifyStatus {
        NEW = 'new',
        SENT = 'sent',
        VERIFIED = 'verified',
        ERROR = 'error',
    }


}
